import { FiShoppingBag } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "@/utils/formatters";
import { WrappedCardFrame } from "./WrappedCardFrame";
import type { RecurringPatternData, WrappedCard } from "../types";

interface RecurringPatternCardProps {
  card: WrappedCard;
}

export const RecurringPatternCard = ({ card }: RecurringPatternCardProps) => {
  const { t } = useTranslation("wrapped");
  const data = card.data as RecurringPatternData | null;
  const averageAmount = data ? (data.average_amount ?? (data.count > 0 ? data.amount / data.count : 0)) : 0;

  return (
    <WrappedCardFrame title={card.title} body={card.body}>
      {data ? (
        <div className="app-panel-raised-inset flex min-w-0 items-center gap-4 p-4 sm:p-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[var(--ds-radius-md)] bg-[var(--app-primary-soft)] text-[var(--app-primary)]" aria-hidden="true">
              <FiShoppingBag size={20} />
            </span>
            <div className="min-w-0 flex-1">
              <p className="break-words text-base font-semibold text-[var(--app-text)]">{data.name}</p>
              <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-[var(--app-text-secondary)]">
                <span>{t("wrapped.recurringCount", { count: data.count })}</span>
                <span className="tabular-nums">{t("wrapped.recurringAmount", { amount: formatCurrency(data.amount) })}</span>
                <span className="tabular-nums">{t("wrapped.averageTicket", { amount: formatCurrency(averageAmount) })}</span>
                {data.previous_count !== undefined ? (
                  <span>{t("wrapped.previousMonthCount", { count: data.previous_count })}</span>
                ) : null}
              </div>
            </div>
        </div>
      ) : null}
    </WrappedCardFrame>
  );
};
